/** 主接口人 */
const ROLE_TYPE_MAIN = 1;
/** 普通接口人 */
const ROLE_TYPE_COMMON = 2;

export const menuList = [
  {
    text: "劳动力首页",
    icon: "home-o",
    url: "/renxiao/index",
    i18nKey: "b_fe_vss__Home_page_31E3",
    visible: true,
    children: [],
  },
  {
    i18nKey: "b_fe_vender_pc_vss__Outsourcing_Employee_UNM0",
    text: "外包员工管理",
    icon: "contacts-fill",
    url: "/renxiao/personnelManagement/list",
    roles: [ROLE_TYPE_MAIN, ROLE_TYPE_COMMON],
    visible: true,
    children: [],
  },
  {
    i18nKey: "b_fe_vender_pc_vss_lms_interfaces_managing_x1rT",
    text: "供应商接口人管理",
    icon: "contacts-fill",
    url: "/renxiao/liaisonOfficerManagment",
    roles: [ROLE_TYPE_MAIN],
    visible: true,
    children: [],
  },
  {
    i18nKey: "b_fe_vender_pc_vss_lms_Accounts_payroll_n1tM",
    text: "员工发薪账户信息提报",
    icon: "contacts-fill",
    url: "/renxiao/memberBankAccount",
    roles: [ROLE_TYPE_MAIN, ROLE_TYPE_COMMON],
    visible: true,
    children: [],
  },
  {
    i18nKey: "b_fe_vss_finance_menu_aMo3",
    text: "电子合同",
    icon: "printing",
    roles: [ROLE_TYPE_MAIN, ROLE_TYPE_COMMON],
    visible: true,
    url: "/micro/finance/labor/contract/list",
    children: [
      {
        i18nKey: "b_fe_vss_finance_menu_5kbl",
        text: "合同列表",
        roles: [ROLE_TYPE_MAIN, ROLE_TYPE_COMMON],
        url: "/micro/finance/labor/contract/list",
        visible: true,
      },
    ],
  },
  {
    i18nKey: "b_fe_vss_finance_menu_7J6d",
    text: "结算管理",
    icon: "bankcard",
    roles: [ROLE_TYPE_MAIN, ROLE_TYPE_COMMON],
    visible: true,
    url: "/micro/finance/labor/settlement/list",
    children: [
      {
        i18nKey: "b_fe_vss_finance_menu_xtHO",
        text: "结算单列表",
        roles: [ROLE_TYPE_MAIN, ROLE_TYPE_COMMON],
        url: "/micro/finance/labor/settlement/list",
        visible: true,
      },
    ],
  },
  {
    i18nKey: "O_Schedule_attendance_IVQc",
    text: "排班考勤",
    icon: "bar-chart",
    roles: [ROLE_TYPE_MAIN, ROLE_TYPE_COMMON],
    visible: true,
    url: "/renxiao/scheduleResult",
    children: [
      {
        i18nKey: "O_As_a_result_scheduling_vxMC",
        text: "排班结果",
        roles: [ROLE_TYPE_MAIN, ROLE_TYPE_COMMON],
        url: "/renxiao/scheduleResult",
        visible: true,
      },
      {
        i18nKey: "b_fe_vender_pc_vss_lms_Attendance_Reports_9MEp",
        text: "考勤报表",
        url: "/renxiao/kaoqin/report",
        roles: [ROLE_TYPE_MAIN, ROLE_TYPE_COMMON],
        visible: true,
        children: [],
      },
    ],
  },
  {
    i18nKey: "O_appraisal_management_Qu4D",
    text: "考核管理",
    icon: "file-o",
    roles: [ROLE_TYPE_MAIN, ROLE_TYPE_COMMON],
    visible: true,
    url: "/renxiao/attendanceRate",
    children: [
      {
        i18nKey: "O_Attendance_personnel_ruQc",
        text: "人员出勤率",
        roles: [ROLE_TYPE_MAIN, ROLE_TYPE_COMMON],
        url: "/renxiao/attendanceRate",
        visible: true,
      },
    ],
  },
];
